module.exports = __webpack_public_path__ + "static/media/clicky1.a614e1f6.gif";